import apiClient from 'ps-components/lib/apiClient';
import { CancelToken } from 'axios';
import { updateJobMatchesValues } from '../JobMatching/OrgJobsActions';
import { getJobPricing } from '../CompensationSummary/CompensationSummaryActions';
import { parseLocation, toLocationDisplayValue } from './helper';
import { truncateDecimals } from '../MarketPricing/helper';
import addAlert from 'ps-components/AlertToast/addAlert';

export const TOGGLE_GEO_LOCATION_ONLY = 'TOGGLE_GEO_LOCATION_ONLY';
export const TOGGLE_GEO_CARD = 'TOGGLE_GEO_CARD';
export const TOGGLE_GEO_CARD_EXPAND = 'TOGGLE_GEO_CARD_EXPAND';
export const TOGGLE_SKILLS_CARD = 'TOGGLE_SKILLS_CARD';
export const TOGGLE_SKILLS_CARD_EXPAND = 'TOGGLE_SKILLS_CARD_EXPAND';
export const GET_JOB_FAMILIES_START = 'GET_JOB_FAMILIES_START';
export const GET_JOB_FAMILIES_SUCCESS = 'GET_JOB_FAMILIES_SUCCESS';
export const GET_JOB_LOCATIONS = 'GET_JOB_LOCATIONS';
export const GET_GEO_DIFFERENTIAL_START = 'GET_GEO_DIFFERENTIAL_START';
export const GET_GEO_DIFFERENTIAL_SUCCESS = 'GET_GEO_DIFFERENTIAL_SUCCESS';
export const GET_GEO_DIFFERENTIAL_FAILED = 'GET_GEO_DIFFERENTIAL_FAILED';
export const UPDATE_GEO_DIFFERENTIAL_OVERRIDE = 'UPDATE_GEO_DIFFERENTIAL_OVERRIDE';
export const SET_SELECTED_SKILL_GEO_DIFFERENTIAL_DATA = 'SET_SELECTED_SKILL_GEO_DIFFERENTIAL_DATA';
export const GET_JOB_PRICING_SUCCESS = 'GET_JOB_PRICING_SUCCESS';
export const GET_JOB_PRICING_FAILED = 'GET_JOB_PRICING_FAILED';
export const UPDATE_SELECTED_JOB_PRICING = 'UPDATE_SELECTED_JOB_PRICING';
export const CLEAR_GEO_DIFFERENTIAL = 'CLEAR_GEO_DIFFERENTIAL';
export const UPDATE_SKILL_DIFFERENTIAL_OVERRIDE = 'UPDATE_SKILL_DIFFERENTIAL_OVERRIDE';
export const APPLY_DIFFERENTIALS_TO_JOB_MATCHES_START = 'UPDATE_JOB_MATCHES_START';
export const APPLY_DIFFERENTIALS_TO_JOB_MATCHES_SUCCESS = 'UPDATE_JOB_MATCHES_SUCCESS';
export const APPLY_DIFFERENTIALS_TO_JOB_MATCHES_FAILED = 'UPDATE_JOB_MATCHES_FAILED';
export const GET_JOB_MATCHES_SUCCESS = 'GET_JOB_MATCHES_SUCCESS';
export const RESET_GEO_STATE = 'RESET_GEO_STATE';
export const RESET_DIFFERENTIALS_TO_INITIAL_STATE = 'RESET_DIFFERENTIALS_TO_INITIAL_STATE';
export const SET_SELECTED_JOB_FAMILY = 'SET_SELECTED_JOB_FAMILY';
export const SET_SELECTED_JOB_LOCATION = 'SET_SELECTED_JOB_LOCATION';
export const TITLE_AUTO_MATCH_SUCCESS = 'TITLE_AUTO_MATCH_SUCCESS';
export const TITLE_AUTO_MATCH_FAILED = 'TITLE_AUTO_MATCH_FAILED';
export const START_TITLE_AUTOMATCH = 'START_TITLE_AUTOMATCH';
export const SET_TITLE = 'SET_TITLE';
export const EDIT_MATCH = 'EDIT_MATCH';
export const CANCEL_EDIT_MATCH = 'CANCEL_EDIT_MATCH';
export const SKILL_DIFFERENTIAL_SUCCESS = 'SKILL_DIFFERENTIAL_SUCCESS';
export const SKILL_DIFFERENTIAL_FAIL = 'SKILL_DIFFERENTIAL_FAIL';
export const TOGGLE_SKILL = 'TOGGLE_SKILL';
export const SET_SELECTED_JOB_MATCHES = 'SET_SELECTED_JOB_MATCHES';
export const SET_GEO_DIFFERENTIAL_IS_REMOVED = 'SET_GEO_DIFFERENTIAL_IS_REMOVED';
export const SET_SKILLS_DIFFERENTIAL_IS_REMOVED = 'SET_SKILLS_DIFFERENTIAL_IS_REMOVED';
export const SET_COMMENT = 'SET_COMMENT';
export const TOGGLE_INCLUDE_COMMENT = 'TOGGLE_INCLUDE_COMMENT';
export const CREATE_AD_HOC_JOB_START = 'CREATE_AD_HOC_JOB_START';
export const CREATE_AD_HOC_JOB_SUCCESS = 'CREATE_AD_HOC_JOB_SUCCESS';
export const CREATE_AD_HOC_JOB_FAILED = 'CREATE_AD_HOC_JOB_FAILED';
export const CALCULATE_PROPOSED_VALUE_START = 'CALCULATE_PROPOSED_VALUE_START';
export const CALCULATE_PROPOSED_VALUE_SUCCESS = 'CALCULATE_PROPOSED_VALUE_SUCCESS';
export const CALCULATE_PROPOSED_VALUE_FAILED = 'CALCULATE_PROPOSED_VALUE_FAILED';
export const SET_HAS_PERFORMED_CALCULATE_ACTION = 'SET_HAS_PERFORMED_CALCULATE_ACTION';
export const GET_CROWD_SOURCED_TITLE_MATCH_SUCCESS = 'GET_CROWD_SOURCED_TITLE_MATCH_SUCCESS';

const JOB_MATCH_UPDATE_FEATURE = 'SKILL_GEO_FEATURE';
export const RESET_SKILLS_STATE = 'RESET_SKILLS_STATE';
export const SET_SELECTED_JOB_TITLE = 'SET_SELECTED_JOB_TITLE';
export const RESET_SKILLS_ERROR = 'RESET_SKILLS_ERROR';
export const GET_DIFFERENTIAL_SUCCESS = 'GET_DIFFERENTIAL_SUCCESS';
export const GET_DIFFERENTIAL_FAIL = 'GET_DIFFERENTIAL_FAIL';
export const SET_SELECTED_JOB_TASKS = 'SET_SELECTED_JOB_TASKS';
export const SET_DIFFERENTIAL_FAIL = 'SET_DIFFERENTIAL_FAIL';
export const SET_DIFFERENTIAL_SUCCESS = 'SET_DIFFERENTIAL_SUCCESS';
export const SET_HAS_CHANGES = 'SET_HAS_CHANGES';
export const SET_GEO_IS_PENDING_REMOVE = 'SET_GEO_IS_PENDING_REMOVE';
export const SET_SKILL_IS_PENDING_REMOVE = 'SET_SKILL_IS_PENDING_REMOVE';
export const SET_INCLUDE_COMMENT = 'SET_INCLUDE_COMMENT';
export const TOGGLE_SKILLS_SEARCH = 'TOGGLE_SKILLS_SEARCH';
export const CANCEL_CHANGES = 'CANCEL_CHANGES';
export const SET_CHANGES_CANCELLED = 'SET_CHANGES_CANCELLED';
export const SEND_OPPORTUNITY_EMAIL_START = 'SEND_OPPORTUNITY_EMAIL_START';
export const SEND_OPPORTUNITY_EMAIL_SUCCESS = 'SEND_OPPORTUNITY_EMAIL_SUCCESS';
export const SEND_OPPORTUNITY_EMAIL_FAIL = 'SEND_OPPORTUNITY_EMAIL_FAIL';
export const SEND_OPPORTUNITY_EMAIL_RESET = 'SEND_OPPORTUNITY_EMAIL_RESET';
export const INITIALIZE_DIFFERENTIALS_START = 'INITIALIZE_DIFFERENTIALS_START';
export const INITIALIZE_DIFFERENTIALS_SUCCESS = 'INITIALIZE_DIFFERENTIALS_SUCCESS';
export const INITIALIZE_DIFFERENTIALS_FAIL = 'INITIALIZE_DIFFERENTIALS_FAIL';

let calculateProposedValueCancelToken;

export function initDifferentials(orgJobId, orgJobCode, orgJobCodeKey, benchmarkYear, displayIn, hasFeature) {
  return async dispatch => {
    try {
      const promises = [];
      promises.push(dispatch({ type: INITIALIZE_DIFFERENTIALS_START }));
      promises.push(dispatch(getJobMatches(orgJobCode, orgJobCodeKey, benchmarkYear)));
      promises.push(dispatch(createAdHocJob(orgJobId)));
      if (hasFeature) {
        promises.push(dispatch(getCrowdSourcedTitleMatch(orgJobId, orgJobCode, orgJobCodeKey, benchmarkYear)));
      }
      promises.push(dispatch(getTargetPricingData(orgJobCode, orgJobCodeKey, displayIn, benchmarkYear)));
      await Promise.all(promises);
      dispatch({ type: INITIALIZE_DIFFERENTIALS_SUCCESS });
    } catch (error) {
      addAlert('Failed to initialize differentials data, please try again later', 'danger');
      console.error(error);
      dispatch({ type: INITIALIZE_DIFFERENTIALS_FAIL, error: error });
    }
  };
}

export function getDifferentials(orgJobCode, orgJobCodeKey, benchmarkYear, jobTitle, orgJobId) {
  return async (dispatch, getState) => {
    try {
      const result = await apiClient.apiGet('/api/market-pricing/skill-geo-differential/getSkillsGeoDifferential', {
        params: {
          orgJobCode: orgJobCode,
          orgJobCodeKey: orgJobCodeKey,
          benchmarkYear: benchmarkYear
        }
      });

      if (result.data.result && result.data.result.differential) {
        const { matchTitle, orgJobId, jobLocationCity, jobLocationState, jobFamily } = result.data.result.differential;
        const title = matchTitle ? matchTitle : jobTitle;

        dispatch({
          type: GET_DIFFERENTIAL_SUCCESS,
          result: { ...result.data.result.differential, matchTitle: title }
        });
        dispatch(skillDifferentialSearch(title));
        dispatch(getJobTasks(title, orgJobId));
        if (jobLocationCity && jobLocationState) {
          const location = toLocationDisplayValue(jobLocationCity, jobLocationState);
          dispatch(getJobLocations());
          dispatch(getJobFamilies(location));
          dispatch(getGeoDifferential(location, jobFamily, true));
        }
      } else if (result.data.reason) {
        dispatch(skillDifferentialSearch(jobTitle));
        dispatch(getJobTasks(jobTitle, orgJobId));
        dispatch({ type: GET_DIFFERENTIAL_FAIL, error: result.data.reason });
      }
    } catch (error) {
      dispatch({ type: GET_DIFFERENTIAL_FAIL, error: error });
    }
  };
}

export function setDifferentials(
  orgJobId,
  orgJobCode,
  orgJobCodeKey,
  benchmarkYear,
  selectedJobMatches,
  geoDifferential,
  skillDifferential,
  jobLocationCity,
  jobLocationState,
  jobFamily,
  selectedSkills,
  comment,
  matchTitle
) {
  return async (dispatch, getState) => {
    try {
      const result = await apiClient.apiGet('/api/market-pricing/skill-geo-differential/setSkillsGeoDifferential', {
        params: {
          orgJobId,
          orgJobCode,
          orgJobCodeKey,
          benchmarkYear,
          selectedJobMatches,
          geoDifferential,
          skillDifferential,
          jobLocationCity,
          jobLocationState,
          jobFamily,
          selectedSkills,
          comment: comment ? comment : '',
          matchTitle
        }
      });

      if (result.data.result && result.data.result.success) {
        dispatch({ type: SET_DIFFERENTIAL_SUCCESS });
      } else {
        dispatch({ type: SET_DIFFERENTIAL_FAIL, error: result.data.reason });
      }
    } catch (error) {
      dispatch({ type: SET_DIFFERENTIAL_FAIL, error: error });
    }
  };
}

export function resetSkillsError() {
  return { type: RESET_SKILLS_ERROR };
}

export function toggleSkill(skill) {
  return dispatch => {
    dispatch({ type: TOGGLE_SKILL, data: skill });
    dispatch(setHasPerformedCalculateAction(true));
    dispatch(setHasChanges(true));
  };
}

export function skillDifferentialSearch(title) {
  return async dispatch => {
    try {
      const result = await apiClient.apiGet('/api/payscale/skills/skillsDifferential', { params: { title: title } });

      if (result.data.report.length > 0) {
        dispatch({ type: SKILL_DIFFERENTIAL_SUCCESS, result: result.data.report });
      } else if (result.data.report.body.reason) {
        dispatch({ type: SKILL_DIFFERENTIAL_FAIL, error: result.data.report.body.reason });
      }
    } catch (error) {
      dispatch({ type: SKILL_DIFFERENTIAL_FAIL, error: error });
    }
  };
}

export function getJobTasks(title, orgJobId) {
  return async dispatch => {
    const titleSuggestions = await apiClient.apiGet('/api/payscale/titleMatch/titleSearch', {
      params: {
        orgJobId: orgJobId,
        title: title,
        workLocation: '',
        jobCode: '',
        additionalSearch: true,
        noJobCode: false
      }
    });

    const titleMatch = titleSuggestions.data.JobTitleSuggestions.find(job => job.JobTitle === title);
    const tasks = titleMatch ? titleMatch.Tasks : [];

    dispatch({ type: SET_SELECTED_JOB_TASKS, data: { tasks } });
  };
}

export function setSelectedJobTitle(title, orgJobId) {
  return async dispatch => {
    dispatch(getJobTasks(title, orgJobId));
    dispatch({ type: SET_SELECTED_JOB_TITLE, data: { title } });
  };
}

export function editMatch() {
  return { type: EDIT_MATCH };
}

export function cancelEditMatch() {
  return { type: CANCEL_EDIT_MATCH };
}
export function overrideTitle(jobTitle) {
  return {
    type: SET_TITLE,
    data: jobTitle
  };
}

const BASE_50TH_REGEX = /.*base.*50.*/i;

export function toggleGeoLocationOnly() {
  return { type: TOGGLE_GEO_LOCATION_ONLY };
}

export function toggleGeoCard() {
  return { type: TOGGLE_GEO_CARD };
}

export function toggleGeoCardExpand() {
  return { type: TOGGLE_GEO_CARD_EXPAND };
}

export function toggleSkillsCard() {
  return { type: TOGGLE_SKILLS_CARD };
}

export function toggleSkillsCardExpand() {
  return { type: TOGGLE_SKILLS_CARD_EXPAND };
}

export function getJobFamilies(location) {
  return async dispatch => {
    try {
      const locationObject = parseLocation(location);
      dispatch({ type: GET_JOB_FAMILIES_START });
      const results = await apiClient.apiGet('/api/market-pricing/skill-geo-differential/jobFamilies', {
        params: {
          locationCity: locationObject.city,
          locationState: locationObject.state
        }
      });
      dispatch({ type: GET_JOB_FAMILIES_SUCCESS, jobFamilies: results.data.jobFamilies });
    } catch (error) {
      console.log(error);
    }
  };
}

export function getJobLocations(featureIsPurchased, searchText) {
  return async dispatch => {
    try {
      const results = await apiClient.apiGet('/api/market-pricing/skill-geo-differential/jobLocations', {
        params: {
          featureIsPurchased,
          searchText
        }
      });
      dispatch({ type: GET_JOB_LOCATIONS, jobLocations: results.data.jobLocations });
      return results.data.jobLocations;
    } catch (error) {
      console.log(error);
    }
  };
}

export function getGeoDifferential(location, jobFamily, retainCurrentOverride) {
  return async dispatch => {
    try {
      const locationObject = parseLocation(location);
      dispatch({ type: GET_GEO_DIFFERENTIAL_START });
      const results = await apiClient.apiGet('/api/market-pricing/skill-geo-differential/geoDifferential', {
        params: {
          locationCity: locationObject.city,
          locationState: locationObject.state,
          jobFamily
        }
      });
      let geoDifferential = results.data.geoDifferential;
      if (geoDifferential) {
        geoDifferential = parseFloat(geoDifferential.toFixed(3));
      }
      if (!retainCurrentOverride) {
        dispatch(setHasChanges(true));
      }
      dispatch({
        type: GET_GEO_DIFFERENTIAL_SUCCESS,
        geoDifferential,
        sampleSize: results.data.sampleSize,
        retainCurrentOverride
      });
      if (!retainCurrentOverride) {
        dispatch(setHasPerformedCalculateAction(true));
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: GET_GEO_DIFFERENTIAL_FAILED });
    }
  };
}

export function updateGeoDifferentialOverride(override) {
  return dispatch => {
    dispatch({ type: UPDATE_GEO_DIFFERENTIAL_OVERRIDE, override: override });
    dispatch(setHasPerformedCalculateAction(true));
    dispatch(setHasChanges(true));
  };
}

export function updateSkillDifferentialOverride(override) {
  return dispatch => {
    dispatch({ type: UPDATE_SKILL_DIFFERENTIAL_OVERRIDE, override: override });
    dispatch(setHasPerformedCalculateAction(true));
    dispatch(setHasChanges(true));
  };
}

export function getTargetPricingData(orgJobCode, orgJobCodeKey, displayIn, benchmarkYear) {
  return async dispatch => {
    try {
      const results = await apiClient.apiGet(
        '/api/market-pricing/skill-geo-differential/targetPricingDataFromPricingView',
        {
          params: {
            orgJobCode: orgJobCode,
            orgJobCodeKey: orgJobCodeKey,
            displayIn: displayIn,
            benchmark_years: [benchmarkYear]
          }
        }
      );

      const jobPricing = results.data.jobPricing;
      let defaultSelectedJobPricing = null;
      let pricingFieldPk = null;

      if (jobPricing?.length > 0) {
        defaultSelectedJobPricing = jobPricing[0].header;
        pricingFieldPk = jobPricing[0].field.field_pk;

        // MPE-5608: Lodash cleanup, find
        const matchedDefaultJobPricing = jobPricing?.find(pricing => {
          return pricing.header.match(BASE_50TH_REGEX);
        });

        if (matchedDefaultJobPricing) {
          defaultSelectedJobPricing = matchedDefaultJobPricing.header;
          pricingFieldPk = matchedDefaultJobPricing.field.field_pk;
        }
      }

      dispatch({ type: GET_JOB_PRICING_SUCCESS, jobPricing, defaultSelectedJobPricing, pricingFieldPk });
    } catch (error) {
      console.log(error);
      dispatch({ type: GET_JOB_PRICING_FAILED });
    }
  };
}

export function updateSelectedJobPricing(selectedJobPricing, jobPricing) {
  return dispatch => {
    const pricingObject = jobPricing?.find(pricing => pricing.header.trim() === selectedJobPricing.trim());
    if (pricingObject) {
      const pricingFieldPk = pricingObject.field.field_pk;
      dispatch({ type: UPDATE_SELECTED_JOB_PRICING, selectedJobPricing, pricingFieldPk });
    }
  };
}

export function setSelectedSkillGeoDifferentialData(
  orgJobId,
  orgJobCode,
  orgJobCodeKey,
  currency,
  jobTitle,
  benchmarkYear,
  displayIn
) {
  return async dispatch => {
    dispatch({
      type: SET_SELECTED_SKILL_GEO_DIFFERENTIAL_DATA,
      orgJobId,
      orgJobCode,
      orgJobCodeKey,
      currency,
      jobTitle,
      benchmarkYear,
      displayIn
    });
  };
}

export function clearGeoDifferential() {
  return dispatch => {
    dispatch({ type: CLEAR_GEO_DIFFERENTIAL });
    dispatch(setHasPerformedCalculateAction(true));
  };
}

export function applyDifferentialsToJobMatches(
  orgJobId,
  orgJobCode,
  orgJobCodeKey,
  benchmarkYear,
  jobMatchIds,
  geoDifferential,
  skillDifferential,
  jobLocation,
  jobFamily,
  skills,
  comment,
  matchTitle,
  displayIn
) {
  return async dispatch => {
    try {
      dispatch({ type: APPLY_DIFFERENTIALS_TO_JOB_MATCHES_START });
      const matchUpdateObjects = [];

      if (jobMatchIds) {
        jobMatchIds.forEach(matchId => {
          const matchObject = {
            matchId: matchId
          };
          if (geoDifferential !== null && geoDifferential !== undefined) {
            matchObject.geo = truncateDecimals(1.0 + geoDifferential, 5);
          }
          if (skillDifferential !== null && skillDifferential !== undefined) {
            matchObject.adj = truncateDecimals(1.0 + skillDifferential, 5);
          }
          if (comment !== null && comment !== undefined) {
            matchObject.comment = comment.replace(/\n/g, '  ');
          }
          matchUpdateObjects.push(matchObject);
        });
      }

      const metaData = { updateType: JOB_MATCH_UPDATE_FEATURE };
      if (jobLocation) {
        metaData.jobLocation = jobLocation;
      }
      if (jobFamily) {
        metaData.jobFamily = jobFamily;
      }
      if (skills) {
        metaData.skills = skills;
      }
      const results = await dispatch(updateJobMatchesValues(orgJobId, matchUpdateObjects, metaData));

      if (results.success) {
        dispatch({
          type: APPLY_DIFFERENTIALS_TO_JOB_MATCHES_SUCCESS,
          isSummaryUpdated: results.isSummaryUpdated === true
        });

        if (results.isSummaryUpdated) {
          const job = { orgJobCode, orgJobCodeKey };
          dispatch(getTargetPricingData(orgJobCode, orgJobCodeKey, displayIn, benchmarkYear));
          dispatch(getJobPricing(job, benchmarkYear, displayIn));
        }
        dispatch(getJobMatches(orgJobCode, orgJobCodeKey, benchmarkYear));
        const location = parseLocation(jobLocation);
        dispatch(
          setDifferentials(
            orgJobId,
            orgJobCode,
            orgJobCodeKey,
            benchmarkYear,
            jobMatchIds,
            geoDifferential,
            skillDifferential,
            location.city,
            location.state,
            jobFamily,
            skills,
            comment,
            matchTitle
          )
        );
      } else {
        dispatch({ type: APPLY_DIFFERENTIALS_TO_JOB_MATCHES_FAILED });
      }
    } catch (error) {
      console.log(error);
      dispatch({ type: APPLY_DIFFERENTIALS_TO_JOB_MATCHES_FAILED });
    }
  };
}

export function getJobMatches(orgJobCode, orgJobCodeKey, benchmarkYear) {
  return async dispatch => {
    try {
      const result = await apiClient.apiGet('/api/market-pricing/jobs/jobMatches', {
        params: {
          orgJobCode: orgJobCode,
          orgJobCodeKey: orgJobCodeKey,
          benchmarkYear: benchmarkYear
        }
      });

      dispatch({
        type: GET_JOB_MATCHES_SUCCESS,
        jobMatches: result.data.jobMatches,
        pricingType: result.data.pricingType
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function resetDifferentialsToInitialState() {
  return { type: RESET_DIFFERENTIALS_TO_INITIAL_STATE };
}

export function resetGeoState() {
  return { type: RESET_GEO_STATE };
}

export function resetSkillsState() {
  return { type: RESET_SKILLS_STATE };
}

export function setSelectedJobFamily(selectedJobFamily) {
  return { type: SET_SELECTED_JOB_FAMILY, selectedJobFamily };
}

export function setSelectedJobLocation(selectedJobLocation) {
  return { type: SET_SELECTED_JOB_LOCATION, selectedJobLocation };
}

export function setSelectedJobMatches(selectedJobMatches) {
  return async dispatch => {
    dispatch({ type: SET_SELECTED_JOB_MATCHES, selectedJobMatches });
    dispatch(setHasPerformedCalculateAction(true));
  };
}

export function setGeoDifferentialIsRemoved(isRemoved) {
  return async dispatch => {
    dispatch({ type: SET_GEO_DIFFERENTIAL_IS_REMOVED, isRemoved });
  };
}

export function setSkillsDifferentialIsRemoved(isRemoved) {
  return async dispatch => {
    dispatch({ type: SET_SKILLS_DIFFERENTIAL_IS_REMOVED, isRemoved });
  };
}

export function setComment(comment) {
  return { type: SET_COMMENT, comment };
}

export function toggleIncludeComment() {
  return { type: TOGGLE_INCLUDE_COMMENT };
}

export function setIncludeComment(includeComment) {
  return { type: SET_INCLUDE_COMMENT, includeComment };
}

export function createAdHocJob(sourceOrgJobId) {
  return async dispatch => {
    try {
      dispatch({ type: CREATE_AD_HOC_JOB_START });
      const result = await apiClient.apiPost('/api/market-pricing/skill-geo-differential/createAdhocJob', {
        orgJobId: sourceOrgJobId
      });

      if (result.data.success) {
        dispatch({ type: CREATE_AD_HOC_JOB_SUCCESS, adHocJob: result.data.adhocJob });
        return result.data.adhocJob;
      } else {
        dispatch({ type: CREATE_AD_HOC_JOB_FAILED });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: CREATE_AD_HOC_JOB_FAILED });
    }
  };
}

export function calculateProposedValue(
  orgJobId,
  jobMatches,
  selectedJobMatches,
  geoDifferential,
  skillDifferential,
  jobPricingFieldPks,
  displayIn,
  benchmarkYear
) {
  const hasGeo = !isNaN(Number.parseFloat(geoDifferential));
  const hasSkill = !isNaN(Number.parseFloat(skillDifferential));

  const matchUpdateObjects = jobMatches.map(jobMatch => {
    const matchId = jobMatch.matchId;
    let matchObject = { matchId: matchId, geo: jobMatch.geo, adj: jobMatch.adj };
    if (selectedJobMatches.includes(matchId)) {
      if (hasGeo) {
        matchObject.geo = (1.0 + geoDifferential).toFixed(3);
      }
      if (hasSkill) {
        matchObject.adj = (1.0 + skillDifferential).toFixed(3);
      }
    }
    return matchObject;
  });
  return async dispatch => {
    dispatch({ type: CALCULATE_PROPOSED_VALUE_START });
    try {
      calculateProposedValueCancelToken && calculateProposedValueCancelToken();
      const result = await apiClient.apiPost(
        '/api/market-pricing/skill-geo-differential/calculateProposedValue',
        {
          orgJobId: orgJobId,
          matches: matchUpdateObjects,
          targetPricingFieldPks: jobPricingFieldPks,
          displayIn: displayIn,
          benchmarkYear: benchmarkYear
        },
        {
          cancelToken: new CancelToken(function executor(cancelToken) {
            calculateProposedValueCancelToken = cancelToken;
          })
        }
      );

      if (result.data.success) {
        dispatch({ type: CALCULATE_PROPOSED_VALUE_SUCCESS, proposedValues: result.data.proposedValues });
      } else {
        dispatch({ type: CALCULATE_PROPOSED_VALUE_FAILED });
      }
    } catch (error) {
      console.log(error);
    }
  };
}

export function setHasPerformedCalculateAction(hasPerformed) {
  return { type: SET_HAS_PERFORMED_CALCULATE_ACTION, hasPerformed };
}

export function getCrowdSourcedTitleMatch(orgJobId, orgJobCode, orgJobCodeKey, benchmarkYear) {
  return async dispatch => {
    try {
      const result = await apiClient.apiGet('/api/market-pricing/jobs/crowdSourcedTitleMatch', {
        params: {
          orgJobId: orgJobId
        }
      });

      if (result.data.success) {
        dispatch({
          type: GET_CROWD_SOURCED_TITLE_MATCH_SUCCESS,
          crowdSourcedTitleMatchJobFamily: result.data.jobFamily,
          crowdSourcedTitle: result.data.crowdSourcedTitle,
          companySourcedTitle: result.data.companySourcedTitle,
          orgJobTitle: result.data.orgJobTitle
        });
      }

      const title = result.data.crowdSourcedTitle ? result.data.crowdSourcedTitle : result.data.orgJobTitle;

      dispatch(getDifferentials(orgJobCode, orgJobCodeKey, benchmarkYear, title, orgJobId));
    } catch (error) {
      console.log(error);
    }
  };
}

export function setHasChanges(hasChanges) {
  return { type: SET_HAS_CHANGES, hasChanges };
}

export function setGeoIsPendingRemove(isPending) {
  return dispatch => {
    dispatch({ type: SET_GEO_IS_PENDING_REMOVE, isPending });
    dispatch(setHasPerformedCalculateAction(true));
  };
}

export function setSkillIsPendingRemove(isPending) {
  return dispatch => {
    dispatch({ type: SET_SKILL_IS_PENDING_REMOVE, isPending });
    dispatch(setHasPerformedCalculateAction(true));
  };
}

export function toggleSkillsSearch() {
  return dispatch => {
    dispatch({ type: TOGGLE_SKILLS_SEARCH });
  };
}
export function cancelChanges() {
  return { type: CANCEL_CHANGES };
}

export function setChangesCancelled(changesCancelled) {
  return { type: SET_CHANGES_CANCELLED, changesCancelled };
}

export function sendOpportunityEmail() {
  return async dispatch => {
    try {
      dispatch({
        type: SEND_OPPORTUNITY_EMAIL_START
      });
      const result = await apiClient.apiPost('/api/market-pricing/skill-geo-differential/sendOpportunityEmail');
      if (result.data.success) {
        dispatch({
          type: SEND_OPPORTUNITY_EMAIL_SUCCESS
        });
      } else {
        dispatch({
          type: SEND_OPPORTUNITY_EMAIL_FAIL
        });
      }
    } catch (error) {
      console.log('Error trying to send email: ', error);
      dispatch({
        type: SEND_OPPORTUNITY_EMAIL_FAIL
      });
    }
  };
}

export function clearSubmitRequest() {
  return { type: SEND_OPPORTUNITY_EMAIL_RESET };
}
